// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y_48xXHOSnUNAj4sI4GV{flex-direction:column;justify-content:center;align-items:center;height:100%;display:flex}.XhHnXehmSYdWVPOtqG7e{color:var(--content-neutral-primary);margin-bottom:20px}.HaZ8mCmOpc0GTqczlvye{color:var(--content-primary-disabled);margin-bottom:10px;font-size:16px;font-weight:500}.tTi5hkuVut0PT0_G2C7A{color:var(--content-primary-disabled);font-size:12px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `y_48xXHOSnUNAj4sI4GV`,
	"empty__icon": `XhHnXehmSYdWVPOtqG7e`,
	"emptyIcon": `XhHnXehmSYdWVPOtqG7e`,
	"empty__title": `HaZ8mCmOpc0GTqczlvye`,
	"emptyTitle": `HaZ8mCmOpc0GTqczlvye`,
	"empty__desc": `tTi5hkuVut0PT0_G2C7A`,
	"emptyDesc": `tTi5hkuVut0PT0_G2C7A`
};
export default ___CSS_LOADER_EXPORT___;
